import React, { useState, useEffect } from "react";
import AiMenu from './AiMenu';
import './Ai.scss';

export default function Ai() {
    const [isAiWriteActive, setIsAiWriteActive] = useState(false);

    const handleShowAiWrite = () => {
        setIsAiWriteActive(!isAiWriteActive);
    }

    // useEffect(() => {
    //     console.log('LOAD');
    // }, []);

    return (
        <>
            {isAiWriteActive &&
                <AiMenu aiMenuToggle={handleShowAiWrite} />
            }
            <section className="ai-section" onClick={handleShowAiWrite}>
                <button className={`${isAiWriteActive ? 'ai-button ai-button_active' : 'ai-button'}`}></button>
                <p className="ai-paragraph">AI Write</p>
            </section>
        </>
    )
}
